export default __webpack_public_path__ + "static/media/Artboard 1 (1).f24ad2e7.jpg";